module.exports = __webpack_public_path__ + "img/IMG_8956.6da3fe10.jpg";